import NotificacionService from 'src/modules/notificacion/notificacionService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'NOTIFICACION_VIEW';

const notificacionViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: notificacionViewActions.FIND_STARTED,
      });

      const record = await NotificacionService.find(id);

      dispatch({
        type: notificacionViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: notificacionViewActions.FIND_ERROR,
      });

      getHistory().push('/notificacion');
    }
  },
};

export default notificacionViewActions;
